import { CommonModule } from "@angular/common"
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http"
import { ApplicationRef, NgModule } from "@angular/core"
import { AngularFireModule } from "@angular/fire"
import { AngularFireAuthModule } from "@angular/fire/auth"
import { AngularFirestoreModule } from "@angular/fire/firestore"
import { AngularFireFunctionsModule } from "@angular/fire/functions"
import { AngularFireStorageModule } from "@angular/fire/storage"
import { FormsModule } from "@angular/forms"
import { MAT_DATE_FORMATS } from "@angular/material/core"
import { BrowserModule } from "@angular/platform-browser"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { RouterModule } from "@angular/router"
import { TrModalsModule } from "@tr/modals"
import { AuthInterceptorService } from "@tr/services"
import { environment } from "../environments/environment"
import { AppComponent } from "./app.component"
import { AppRoutes } from "./app.routing"
import { ForbiddenComponent } from "./forbidden/forbidden.component"
import { LayoutModule } from "./layouts/layout.module"

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes),
    AngularFireModule.initializeApp(environment.firebase),
    HttpClientModule,
    LayoutModule,
    TrModalsModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
  ],
  declarations: [
    AppComponent,
    ForbiddenComponent,
  ],
  entryComponents: [
    AppComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "M/D/YY",
        },
        display: {
          dateInput: "M/D/YY",
          monthYearLabel: "MMM YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
        },
      },
    },
    // { provide: FUNCTIONS_ORIGIN, useValue: "http://localhost:5000" },
  ],
})
export class AppModule {
  public ngDoBootstrap(appRef: ApplicationRef): void {
    appRef.bootstrap(AppComponent)
    if (window.Cypress) {
      window.appRef = appRef
    }
  }
}
